class ExxtraBookingNavigation {

    constructor() {

        this.steps = [...document.querySelectorAll(".valet-step")];

        if (!this.steps.length) return;

        this.currentStep = 1;

        this.bind();

        this.showStep(this.currentStep);

    }

    bind() {

        document.addEventListener("click", (event) => {

            const button = event.target.closest("button");

            if (!button) return;

            if (button.hasAttribute("data-booking-next")) {

                event.preventDefault();
                this.next();
                return;

            }

            if (button.hasAttribute("data-booking-back")) {

                event.preventDefault();
                this.back();
                return;

            }

        });

        document.addEventListener(
            "valet:elevator-confirmed",
            () => {

                this.showStep(
                    this.currentStep + 1
                );

            }
        );

    }

    next() {

        console.log("NEXT()", this.currentStep);

        if (this.currentStep >= this.steps.length) return;

        /*
        |--------------------------------------------------------------------------
        | Step 1 Validation
        |--------------------------------------------------------------------------
        */

        if (this.currentStep === 1) {

            if (!window.valetBooking.duration) {

                alert("Please select a storage duration.");

                return;

            }

        }

        /*
        |--------------------------------------------------------------------------
        | Step 2 Insurance
        |--------------------------------------------------------------------------
        */

        if (this.currentStep === 2) {

            if (window.ValetInsuranceModal) {

                console.log("OPEN INSURANCE MODAL");

                window.ValetInsuranceModal.open();

                return;

            }

        }

        /*
        |--------------------------------------------------------------------------
        | Step 3 Validation
        |--------------------------------------------------------------------------
        */

        if (this.currentStep === 3) {

            if (!window.valetBooking.deliveryDate) {

                alert("Please select a delivery date.");

                return;

            }

        }

        /*
        |--------------------------------------------------------------------------
        | Step 4 Confirmation
        |--------------------------------------------------------------------------
        */

        if (this.currentStep === 4) {

            if (
                window.ValetStep4 &&
                !window.ValetStep4.validate()
            ) {

                console.log("STEP 4 INVALID");

                return;

            }

            if (
                window.valetBooking.address.elevator === "No" &&
                window.ValetElevatorModal
            ) {

                console.log("OPENING ELEVATOR MODAL");

                window.ValetElevatorModal.open();

                return;

            }

        }

        /*
        |--------------------------------------------------------------------------
        | Step 5 Validation
        |--------------------------------------------------------------------------
        */

        if (this.currentStep === 5) {

            if (!window.valetBooking.collectionDate) {

                alert("Please select a collection date.");

                return;

            }

        }

        this.showStep(this.currentStep + 1);

    }

    back() {

        if (this.currentStep <= 1) return;

        this.showStep(this.currentStep - 1);

    }

    showStep(step) {

        this.currentStep = step;

        this.steps.forEach((item) => {

            const itemStep = Number(item.dataset.step);

            item.hidden = itemStep !== step;

        });

        this.updateProgress();

        this.initializeStep(step);

    }

    updateProgress() {

        document
            .querySelectorAll("[data-progress-step]")
            .forEach((item) => {

                const step = Number(item.dataset.progressStep);

                item.classList.toggle(
                    "is-active",
                    step === this.currentStep
                );

                item.classList.toggle(
                    "is-complete",
                    step < this.currentStep
                );

            });

    }

    initializeStep(step) {

        switch (step) {

            case 2:

                this.initializeQuantity();

                break;

            case 3:

                this.initializeDeliveryCalendar();

                break;

            case 4:

                this.initializeDeliveryAddress();

                break;

            case 5:

                this.initializeCollectionCalendar();

                break;

            }

    }

    initializeQuantity() {

        if (window.ValetStep2) {

            window.ValetStep2.init();

        }

    }

    initializeDeliveryCalendar() {

        if (window.ValetStep3) {

            window.ValetStep3.init();

        }

    }

    initializeDeliveryAddress() {

        if (window.ValetStep4) {

            window.ValetStep4.init();

        }

    }

    initializeCollectionCalendar() {

        if (window.ValetStep5) {

            window.ValetStep5.init();

        }

    }

}

document.addEventListener("DOMContentLoaded", () => {

    window.ValetNavigation =
        new ExxtraBookingNavigation();

});